module.exports = __webpack_public_path__ + "media/images/mypage_coupon-bb19fdc0988390e60dd4afd813db8f06.png";